import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
// @material-ui/icons components
import MenuIcon from "@material-ui/icons/Menu";

// import Avatar from "@material-ui/core/Avatar";
//import ZoomIn from "@material-ui/icons/ZoomIn";

// core components
// import UserDropdown from "components/Dropdowns/UserDropdown.js";

import componentStyles from "assets/theme/components/navbars/admin-navbar.js";
import tenantTheme from "tenantTheme.js";

const useStyles = makeStyles(componentStyles);

export default function AdminNavbar({ openSidebarResponsive }) {
  const classes = useStyles();
  const theme = useTheme();
  const [showSearch, setShowSearch] = React.useState(false);
  return (
    <>
      <AppBar
        position="relative"
        elevation={0}
        classes={{ root: classes.appBarRoot }}
        // White rather than a tenant fill: this bar carries the tenant's own
        // logo, which would vanish against its own primary. Matches the white
        // sidebar and the neutral desktop header.
        style={{
          background: theme.palette.white.main,
          borderBottom: "1px solid " + theme.palette.gray[200],
        }}
      >
        <Toolbar disableGutters>
          <Container
            maxWidth={false}
            component={Box}
            classes={{ root: classes.containerRoot }}
          >
            <Box
              display="flex"
              justifyContent="left"
              alignItems="left"
              width="100%"
              marginTop="1rem"
              marginBottom="1rem"
            >
              {/* Menu hard left, logo hard right, at every width. These used to
                  swap sides above the sm breakpoint, which put both of them in
                  the right-hand corner on tablets. */}
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className={clsx({
                  [classes.displayNone]: showSearch,
                })}
              >
                <Hidden xlUp implementation="css">
                  <IconButton onClick={openSidebarResponsive}>
                    <Box
                      component={MenuIcon}
                      color={theme.palette.tenant.main}
                      width="1.5rem!important"
                      height="1.5rem!important"
                    />
                  </IconButton>
                </Hidden>
                {/* <Hidden smUp implementation="css">
                  <IconButton onClick={() => setShowSearch(true)}>
                    <Box
                      component={ZoomIn}
                      color={theme.palette.white.main}
                      width="1.5rem!important"
                      height="1.5rem!important"
                    />
                  </IconButton>
                </Hidden> */}
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginLeft="auto"
                className={clsx({
                  [classes.displayNone]: showSearch,
                })}
              >

                {/* Tenant logos are wordmarks of varying width, so cap the
                    height and let the width follow rather than forcing a square. */}
                <img
                  src={tenantTheme.logo}
                  alt={tenantTheme.title}
                  style={{ height: "40px", width: "auto", maxWidth: "160px" }}
                />
                {/* <UserDropdown /> */}
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}
AdminNavbar.defaultProps = {
  openSidebarResponsive: () => {},
};

AdminNavbar.propTypes = {
  // use this to make the Sidebar open on responsive mode
  openSidebarResponsive: PropTypes.func.isRequired,
};
